// Configurable tooltip copy — replace freely, no code changes elsewhere required.
export const OVERDUE_VALUE_TIMELINE_INFO_TEXT =
  "Hier wird der wirtschaftliche Wert überfälliger, noch nicht abgeschlossener Vorgänge im " +
  "Zeitverlauf visualisiert. Ein Objekt fließt in die Kurve ein, " +
  "sobald sein definierter Zieltermin überschritten ist, und fällt heraus, sobald es " +
  "abgeschlossen wird. Dadurch entsteht ein tagesaktuelles Bild der aktuell gebundenen Werte, " +
  "ein Frühindikator für Verzögerungen im Prozess, bevor sie an anderer Stelle sichtbar werden.";
